<template>
    <div>
        <rkm-area
            title="Paciente"
            v-if="pacienteExists"
            type="fieldset"
            no-margin-top
        >
            <rkm-row>
                <rkm-col class="flex-grow-1">
                    <rkm-row>
                        <rkm-col>
                            <h4>
                                {{ data.form.paciente.cidadao.nome }}

                                <template v-if="data.form.paciente.cidadao.nomeSocial">
                                    <template v-if="data.form.paciente.cidadao.nomeSocial">
                                        <strong>({{ data.form.paciente.cidadao.nomeSocial }})</strong>
                                    </template>

                                    <template v-else>
                                        ({{ data.form.paciente.cidadao.nomeSocial }})
                                    </template>
                                </template>
                            </h4>
                        </rkm-col>
                    </rkm-row>

                    <rkm-row>
                        <rkm-col cols="3">
                            <p>
                                <strong>Prontuário:</strong>
                                {{ data.form.paciente.prontuario }}
                            </p>
                            <p>
                                <strong>Telefone:</strong>
                                <template v-if="data.form.paciente.cidadao.telefonePrincipal">
                                    {{ data.form.paciente.cidadao.telefonePrincipal.numero  | formatPhoneOrCellPhone }}
                                </template>
                                <template v-else>
                                    -
                                </template>
                            </p>
                            <p>
                                <strong>Sexo:</strong>
                                <template v-if="data.form.paciente.cidadao.sexo">
                                    {{ data.form.paciente.cidadao.sexo.descricao }}
                                </template>
                                <template v-else>
                                    -
                                </template>
                            </p>
                        </rkm-col>

                        <rkm-col cols="3">
                            <p>
                                <strong>CPF:</strong>
                                <template v-if="data.form.paciente.cidadao.cpf">
                                    {{ data.form.paciente.cidadao.cpf | formatCpf }}
                                </template>
                                <template v-else>
                                    -
                                </template>
                            </p>
                            <p>
                                <strong>Data de nascimento:</strong>
                                {{ data.form.paciente.cidadao.dataNascimento | formatDate }}
                            </p>
                            <p>
                                <strong>
                                    Nome da mãe:
                                </strong>
                                <template v-if="data.form.paciente.cidadao.nomeMae">
                                    {{ data.form.paciente.cidadao.nomeMae }}
                                </template>
                                <template v-else>
                                    <i>Desconhecido</i>
                                </template>
                            </p>
                        </rkm-col>

                        <rkm-col>
                            <p>
                                <strong>CNS:</strong>
                                <template v-if="data.form.paciente.cidadao.cns">
                                    {{ data.form.paciente.cidadao.cns | formatCns }}
                                </template>
                                <template v-else>
                                    -
                                </template>
                            </p>
                            <p>
                                <strong>Idade:</strong>
                                <template v-if="data.form.paciente.cidadao.idade">
                                    {{ data.form.paciente.cidadao.idade.anos }} anos,
                                    {{ data.form.paciente.cidadao.idade.meses }} meses e
                                    {{ data.form.paciente.cidadao.idade.dias }} dias
                                </template>
                                <template v-else>
                                    -
                                </template>
                            </p>
                            <p>
                                <strong>Unidade de referência:</strong>
                                <template v-if="data.form.paciente.unidade">
                                    {{ data.form.paciente.unidade.nomeFantasia }}
                                </template>
                                <template v-else>
                                    -
                                </template>
                            </p>
                        </rkm-col>
                    </rkm-row>
                </rkm-col>
            </rkm-row>
        </rkm-area>
    </div>
</template>

<script>

// Filters.
import format from '@/filters/formats'

//Enuns.
import preferenciaNome from '@/enums/cadastro/cidadao/preferenciaNome'

export default {
    computed: {
        pacienteExists() {
            return this.data.form && this.data.form.paciente
        },
    },
    data: () => ({
        enums: {
            preferenciaNome
        },
    }),
    filters: {
        ...format,
    },
    props: {
        data: { type: Object, required: true },
    },
}
</script>
<style scoped>
p {
    margin: 0px;
}
.col-svg {
    text-align: center !important;
}
.icon {
    width: auto !important;
    height: 96px !important;
    color: #007bff !important;
}
</style>